import * as React from 'react';
import { renderTable } from './renderTable';
import { toFixedDecimal } from '../../../core/formatter/formatNumber';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';

export interface EnergiekostenPrognoseOptionenProps {
    data: any;
    disabled?: boolean;
    inflation: any;
    onInflationChange: (data: any) => void;
    onOptionChange: (data: string) => void;
    optionen: any;
    selection: string;
}

export class EnergiekostenPrognoseOptionen extends React.Component<EnergiekostenPrognoseOptionenProps, {}> {

    constructor(props: any) {
        super(props);
        this.onInflationChange = this.onInflationChange.bind(this);
        this.onOptionChange = this.onOptionChange.bind(this);
    }

    getTable(): any {
        const tbody: any = this.getTableBody();
        const thead: any = this.getTableHeader();

        return {
            rows: [...thead.rows, ...tbody.rows],
            rowStyles: [...thead.rowStyles, ...tbody.rowStyles],
        };
    }

    getTableBody(): any {
        const tbody: any = { rows: [], rowStyles: [] };
        tbody.rows.push([
            'Szenarienwahl:',
            'Info:',
        ]);
        tbody.rowStyles.push([
            [['width:230', 'top', 'bold', 'underline']],
            [['width:345', 'top', 'bold', 'underline']],
        ]);
        tbody.rows.push([
            <>
                {this.renderSelection()}
                {this.renderInflation()}
            </>,
            'Die Prognose basiert auf Daten des Umweltbundesamts (siehe Quellen).\n\n' +
            'Wählen Sie die Option "Eigene Annahmen", um in der Prognose-Tabelle eigene Werte für Preissteigerungen oder Absolutpreise anzuwenden.',
        ]);
        tbody.rowStyles.push([
            [['width:230', 'top']],
            [['width:345', 'top']],
        ]);

        return tbody;
    }

    getTableHeader(): any {
        const thead: any = { rows: [], rowStyles: [] };
        thead.rows.push([
            <div style={{ paddingRight: 30, display: 'inline-flex', fontWeight: 600 }}>
                Prognose-Optionen / Info{this.renderHelp()}
            </div>,
        ]);
        thead.rowStyles.push([
            [['width:589', 'title'], { paddingLeft: 10, borderTopLeftRadius: '0pt', borderTopRightRadius: '0pt' }],
        ]);

        return thead;
    }

    onInflationChange(event: any): void {
        const data: any = this.props.inflation || {};
        const target: any = event.target || {};
        let checked: boolean = data.checked;
        let value: number = data.value;

        if (target.type === 'checkbox') {
            checked = target.checked;
        } else if (target.type === 'number') {
            value = target.value;
        }
        this.props.onInflationChange({ checked, value });
    }

    onOptionChange(event: any): void {
        this.props.onOptionChange(event.target.value);
    }

    render(): JSX.Element {
        return renderTable(this.getTable());
    }

    renderHelp(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ marginLeft: 5, display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label='Energiekosten-Projektion - Prognose-Optionen'
                helpKey='energiekosten_projektion_prognose_optionen'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderInflation(): JSX.Element {
        const inflation: any = this.props.inflation || {};
        const checked: boolean = inflation.checked;
        const disabled: boolean = this.props.disabled;
        const value: number = inflation.value;

        return (
            <div style={{ marginTop: 18, display: 'flex', alignItems: 'center' }}>
                <input
                    key='input-inflation'
                    id='input-inflation'
                    type='checkbox'
                    checked={checked}
                    disabled={disabled}
                    onChange={this.onInflationChange}
                />
                <label
                    key='label-inflation'
                    htmlFor='input-inflation'
                >
                    Jährliche Inflation:
                </label>
                <input
                    style={{ width: 36, marginRight: 2, marginLeft: 2 }}
                    type='number'
                    value={value !== null && !isNaN(+value) ? toFixedDecimal(value, 2) : ''}
                    disabled={disabled}
                    onChange={this.onInflationChange}
                />
                %
            </div>
        );
    }

    renderSelection(): JSX.Element[] {
        const disabled: boolean = this.props.disabled;
        const optionen: any = this.props.optionen || {};
        const selection: string = this.props.selection || null;

        return Object.keys(optionen).map((key: string, index: number) => {
            const checked: boolean = key === selection;
            const option: string = optionen[key] || '';

            return (
                <div key={`option-${index}`} style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        key={`input-selection-${key}`}
                        id={`input-selection-${key}`}
                        name='optionen'
                        type='radio'
                        value={key}
                        checked={checked}
                        disabled={disabled}
                        onChange={this.onOptionChange}
                    />
                    <label
                        key={`label-selection-${key}`}
                        htmlFor={`input-selection-${key}`}
                    >
                        {option}
                    </label>
                </div>
            );
        });
    }
}
